<div class="create-user-page">
    <div class="page-header">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h1 class="page-title">CREAR USUARIO</h1>
                <p class="page-subtitle text-muted">
                    Registre un nuevo usuario completando la información personal, credenciales de acceso y configuración de rol
                </p>
            </div>
        </div>
    </div>
    <div class="page-content">
        <mat-card class="form-card">

        <mat-card-content>
            <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
                <!-- Información Personal -->
                <div class="form-section">
                    <h6 class="section-title d-flex align-items-center mb-3">
                        <i class="ri-user-line me-2 text-primary"></i>
                        Información Personal
                    </h6>
                    
                <div class="form-grid personal-grid">
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Nombre</mat-label>
                            <input matInput formControlName="firstName" placeholder="Ingrese nombre" inputmode="text">
                            <mat-error *ngIf="userForm.get('firstName')?.hasError('required')">
                                {{ getErrorMessage('firstName') }}
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Apellido</mat-label>
                            <input matInput formControlName="lastName" placeholder="Ingrese apellido" inputmode="text">
                            <mat-error *ngIf="userForm.get('lastName')?.hasError('required')">
                                {{ getErrorMessage('lastName') }}
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Teléfono</mat-label>
                            <input matInput formControlName="phone" placeholder="+1 234 567 8900" inputmode="tel">
                            <mat-error *ngIf="userForm.get('phone')?.hasError('required')">
                                {{ getErrorMessage('phone') }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Información de Acceso -->
                <div class="form-section">
                    <h6 class="section-title d-flex align-items-center mb-4">
                        <i class="ri-lock-line me-2 text-primary"></i>
                        Información de Acceso
                    </h6>
                    
                    <!-- Email, Contraseña y Confirmación en una sola línea -->
                    <div class="form-grid access-grid">
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Correo Electrónico</mat-label>
                            <input matInput formControlName="email" type="email" placeholder="usuario@opb.com" inputmode="email">
                            <mat-error *ngIf="userForm.get('email')?.hasError('required')">
                                {{ getErrorMessage('email') }}
                            </mat-error>
                            <mat-error *ngIf="userForm.get('email')?.hasError('email')">
                                {{ getErrorMessage('email') }}
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field password-field">
                            <mat-label>Contraseña</mat-label>
                            <input matInput formControlName="password" type="password" placeholder="Mínimo 8 caracteres, incluir mayúscula, número y carácter especial">
                            <mat-error *ngIf="userForm.get('password')?.hasError('required')">
                                {{ getErrorMessage('password') }}
                            </mat-error>
                            <mat-error *ngIf="userForm.get('password')?.hasError('minlength')">
                                {{ getErrorMessage('password') }}
                            </mat-error>
                            <mat-error *ngIf="userForm.get('password')?.hasError('pattern')">
                                {{ getErrorMessage('password') }}
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field password-field">
                            <mat-label>Confirmar Contraseña</mat-label>
                            <input matInput formControlName="confirmPassword" type="password" placeholder="Confirme la contraseña">
                            <mat-error *ngIf="userForm.get('confirmPassword')?.hasError('required')">
                                {{ getErrorMessage('confirmPassword') }}
                            </mat-error>
                            <mat-error *ngIf="userForm.get('confirmPassword')?.hasError('passwordMismatch')">
                                {{ getErrorMessage('confirmPassword') }}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Indicador de requisitos de contraseña -->
                    <div class="password-requirements">
                        <p class="requirements-title">Requisitos de la contraseña:</p>
                        <ul class="requirements-list">
                            <li [class.valid]="userForm.get('password')?.value?.length >= 8" [class.invalid]="userForm.get('password')?.value?.length < 8 && userForm.get('password')?.value?.length > 0">
                                <i class="ri-check-line" *ngIf="userForm.get('password')?.value?.length >= 8"></i>
                                <i class="ri-close-line" *ngIf="userForm.get('password')?.value?.length < 8 && userForm.get('password')?.value?.length > 0"></i>
                                Mínimo 8 caracteres
                            </li>
                            <li [class.valid]="hasUpperCase(userForm.get('password')?.value)" [class.invalid]="!hasUpperCase(userForm.get('password')?.value) && userForm.get('password')?.value?.length > 0">
                                <i class="ri-check-line" *ngIf="hasUpperCase(userForm.get('password')?.value)"></i>
                                <i class="ri-close-line" *ngIf="!hasUpperCase(userForm.get('password')?.value) && userForm.get('password')?.value?.length > 0"></i>
                                Al menos una mayúscula
                            </li>
                            <li [class.valid]="hasNumber(userForm.get('password')?.value)" [class.invalid]="!hasNumber(userForm.get('password')?.value) && userForm.get('password')?.value?.length > 0">
                                <i class="ri-check-line" *ngIf="hasNumber(userForm.get('password')?.value)"></i>
                                <i class="ri-close-line" *ngIf="!hasNumber(userForm.get('password')?.value) && userForm.get('password')?.value?.length > 0"></i>
                                Al menos un número
                            </li>
                            <li [class.valid]="hasSpecialChar(userForm.get('password')?.value)" [class.invalid]="!hasSpecialChar(userForm.get('password')?.value) && userForm.get('password')?.value?.length > 0">
                                <i class="ri-check-line" *ngIf="hasSpecialChar(userForm.get('password')?.value)"></i>
                                <i class="ri-close-line" *ngIf="!hasSpecialChar(userForm.get('password')?.value) && userForm.get('password')?.value?.length > 0"></i>
                                Al menos un carácter especial (&#64;$!%*?&#38;#)
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Configuración del Usuario -->
                <div class="form-section">
                    <h6 class="section-title d-flex align-items-center mb-3">
                        <i class="ri-settings-line me-2 text-primary"></i>
                        Configuración del Usuario
                    </h6>
                    
                    <div class="form-grid settings-grid">
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Rol</mat-label>
                            <mat-select formControlName="role">
                                <mat-option *ngFor="let role of roles" [value]="role.value">
                                    {{ role.label }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="userForm.get('role')?.hasError('required')">
                                {{ getErrorMessage('role') }}
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field *ngIf="shouldShowClientSelect()" appearance="outline" class="form-field">
                            <mat-label>Cliente</mat-label>
                            <input matInput
                                   type="text"
                                   placeholder="Busque y seleccione un cliente"
                                   [formControl]="clientControl"
                                   [matAutocomplete]="auto">
                            <mat-autocomplete #auto="matAutocomplete"
                                              [displayWith]="displayClient"
                                              (optionSelected)="onClientSelected($event)">
                                <mat-option *ngIf="isLoadingClients" value="" disabled>
                                    Cargando clientes...
                                </mat-option>
                                <mat-option *ngFor="let client of filteredClients | async" [value]="client">
                                    {{ client.cliente }}
                                </mat-option>
                                <mat-option *ngIf="!isLoadingClients && clients.length === 0" value="" disabled>
                                    No hay clientes disponibles
                                </mat-option>
                            </mat-autocomplete>
                            <mat-error *ngIf="userForm.get('clientId')?.hasError('required')">
                                {{ getErrorMessage('clientId') }}
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field *ngIf="shouldShowConsigneeSelect()" appearance="outline" class="form-field">
                            <mat-label>Consignatario</mat-label>
                            <mat-select formControlName="consigneeId">
                                <mat-option *ngIf="isLoadingConsignees" value="" disabled>
                                    Cargando consignatarios...
                                </mat-option>
                                <mat-option *ngFor="let c of consignees" [value]="c.consigneeId">
                                    {{ c.consigneeShortName }}
                                </mat-option>
                                <mat-option *ngIf="!isLoadingConsignees && consignees.length === 0" value="" disabled>
                                    No hay consignatarios disponibles
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="userForm.get('consigneeId')?.hasError('required')">
                                Este campo es requerido
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field *ngIf="shouldShowTransportistaSelect()" appearance="outline" class="form-field">
                            <mat-label>Transportista</mat-label>
                            <mat-select formControlName="transportistaId">
                                <mat-option *ngIf="isLoadingTransportistas" value="" disabled>
                                    Cargando transportistas...
                                </mat-option>
                                <mat-option *ngFor="let t of transportistas" [value]="t.transportistaId">
                                    {{ t.transportistaName }}
                                </mat-option>
                                <mat-option *ngIf="!isLoadingTransportistas && !transportistasLoadError && transportistas.length === 0" value="" disabled>
                                    No hay transportistas disponibles
                                </mat-option>
                            </mat-select>
                            <mat-hint *ngIf="transportistasLoadError" class="text-danger">{{ transportistasLoadError }}</mat-hint>
                            <mat-error *ngIf="userForm.get('transportistaId')?.hasError('required')">
                                Este campo es requerido
                            </mat-error>
                        </mat-form-field>

                        <div class="form-field checkbox-field">
                            <mat-checkbox formControlName="isActive" color="primary">
                                Usuario Activo
                            </mat-checkbox>
                        </div>
                    </div>
                </div>

                <!-- Módulos del Usuario -->
                <div class="form-section">
                    <h6 class="section-title d-flex align-items-center mb-3">
                        <i class="ri-apps-line me-2 text-primary"></i>
                        Módulos del Usuario
                    </h6>
                    <p class="text-muted mb-3">
                        Seleccione los módulos que el usuario podrá visualizar en el sistema
                    </p>
                    
                    <div *ngIf="isLoadingModules" class="loading-modules">
                        <i class="ri-loader-4-line animate-spin me-2"></i>
                        Cargando módulos disponibles...
                    </div>

                    <div *ngIf="!isLoadingModules" class="modules-grid">
                        <div *ngFor="let module of availableModules" class="module-checkbox-item">
                            <mat-checkbox 
                                [checked]="isModuleSelected(module.code)"
                                (change)="onModuleToggle(module.code, $event)"
                                color="primary">
                                <div class="module-info">
                                    <span class="module-name">{{ module.name }}</span>
                                    <span class="module-description" *ngIf="module.description">
                                        {{ module.description }}
                                    </span>
                                </div>
                            </mat-checkbox>
                        </div>
                    </div>

                    <div *ngIf="!isLoadingModules && availableModules.length === 0" class="no-modules">
                        <p class="text-muted">No hay módulos disponibles</p>
                    </div>
                </div>

                <!-- Botones de acción -->
                <div class="form-actions">
                    <button type="button" mat-button (click)="onCancel()" [disabled]="isLoading">
                        <i class="ri-arrow-left-line me-2"></i>
                        Cancelar
                    </button>
                    <button type="submit" mat-raised-button color="primary" [disabled]="userForm.invalid || isLoading">
                        <span *ngIf="!isLoading">
                            <i class="ri-user-add-line me-2"></i>
                            Crear Usuario
                        </span>
                        <span *ngIf="isLoading">
                            <i class="ri-loader-4-line animate-spin me-2"></i>
                            Creando...
                        </span>
                    </button>
                </div>
            </form>
        </mat-card-content>
        </mat-card>
    </div>
</div> 